import React from "react";
import { useCSVDownloader } from "react-papaparse";

export const FileDownloader = ({ content, filename }) => {
  const { CSVDownloader, Type } = useCSVDownloader();

  return (
    <CSVDownloader
      className="downloadFile"
      type={Type.Button}
      filename={filename}
      data={content}
      bom={true}
      config={{
        delimiter: ";",
      }}
    >
      <span>Télécharger {filename}</span>
    </CSVDownloader>
  );
};
